<label for="feature_{{feature.id}}">
  {{ feature.header }}@if (feature.unitHeader) {
  <span>, {{ feature.unitHeader }}</span>
}
@if (isRequired()) {
  <span> *</span>
}
@if (feature.comment) {
  <span nbTooltip="{{feature.comment}}">
    <tui-icon icon="lightbulb"/>
  </span>
}
</label>

<div class="accordion-item__right">
  <form [formGroup]="form" style="width: 100%;">
    <div style="display: flex; width: 100%;">
      <input nbInput
        type="text"
        fullWidth
        maxlength="255"
        fieldSize="medium"
        formControlName="header"
        i18n-placeholder="@@Nazvanie" placeholder="Название"
        />
      <input nbInput
        class="ms-2"
        type="text"
        fullWidth
        fieldSize="medium"
        formControlName="url"
        i18n-placeholder="@@Ssylka" placeholder="Ссылка"
        />
    </div>

    @if (featureLinkValue.invalid && featureLinkValue.errors && (featureLinkValue.dirty || featureLinkValue.touched)) {
      <div>
        @if (featureLinkValue.hasError('featureLink')) {
          <div class="text-danger" i18n="@@FeatureValueIncorrectError">
        Не корректное значение
      </div>
        }
      </div>
    }
  </form>
  <div class="accordion-item__right-info">
    @if (feature.fromMasterCard) {
      <div class="state-master-card" i18n-nbTooltip="@@FeatureFromMasterCard" nbTooltip="Характеристика заполнена из мастер карты">
        <tui-icon icon="credit-card"/>
      </div>
    }
    @if (form.valid && isShowEmptyWarning()) {
      <div class="state-warn">
        <tui-icon icon="triangle-alert"/>
      </div>
    }
    @if (form.invalid) {
      <div class="state-err">
        <tui-icon icon="circle-alert"/>
      </div>
    }
    @if (form.valid && !isEmpty()) {
      <div class="state-success">
        <tui-icon icon="check"/>
      </div>
    }
    @if (featureLink) {
      <a [routerLink]="['/cabinet/pim/feature/edit/', feature.featureId]"
        class="entityID"
        target="_blank"
        i18n-nbTooltip="@@OpenFeatureInNewWindow"
        nbTooltip="Открыть характеристику в новом окне"
        >
        #{{ feature.featureId }}
      </a>
    }
    @if (showRemoveButton) {
      <button nbButton ghost size="tiny" status="danger" (click)="removeEvent.emit()" nbTooltip="Удалить характеристику МК" i18n-nbTooltip="@@DeleteMasterCardFeature">
        <tui-icon icon="trash-2"/>
      </button>
    }
  </div>
</div>
